import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { map, Observable } from 'rxjs';
import {
  ICameraItem,
  ICameraParams,
  ICameraPayload,
  ICameraResponseModel,
  ICameraTestConnectionResult,
  ITestCameraConnectionCommand,
} from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class CameraApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/cameras';

  getAllCameras(filter?: ICameraParams): Observable<ICameraResponseModel> {
    return this.http.getWithHeaders(this.apiUrl, filter).pipe(
      map(res => ({
        items: res.body ?? [],
        total: Number(res.headers.get('X-Pagination-Total') ?? 0),
      })),
    );
  }

  setCamera(payload: ICameraPayload): Observable<unknown> {
    return this.http.post(this.apiUrl, payload);
  }

  getCameraById(id: string): Observable<ICameraItem> {
    return this.http.get(this.apiUrl + '/' + id);
  }

  updateCameraById(id: string, payload: ICameraPayload): Observable<unknown> {
    return this.http.put(this.apiUrl + '/' + id, payload);
  }

  deleteCamera(id: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + id);
  }

  /** POST test-connection (право cameras:manage) — снимок кадра как imageBase64. */
  testCameraConnection(
    body: ITestCameraConnectionCommand,
  ): Observable<ICameraTestConnectionResult> {
    return this.http.post(this.apiUrl + '/test-connection', body);
  }
}
